var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 272 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8418 134.278C54.8418 130.136 51.4839 126.778 47.3418 126.778C43.1996 126.778 39.8418 130.136 39.8418 134.278H54.8418ZM39.8418 134.278C39.8418 140.098 39.8187 145.466 40.5172 149.765C41.2654 154.371 43.0245 159.016 47.511 162.332C51.5349 165.305 56.737 166.396 62.2067 166.945C67.847 167.512 75.1617 167.601 84.3544 167.601V152.601C75.0408 152.601 68.4757 152.499 63.7062 152.02C58.7662 151.524 57.0284 150.714 56.4257 150.268C56.2856 150.165 55.7314 149.873 55.323 147.359C54.8648 144.539 54.8418 140.606 54.8418 134.278H39.8418Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.073 160.034L78.4273 187.747L78.1212 132.729L113.073 160.034Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.158 81.7721C217.158 85.9142 220.516 89.2721 224.658 89.2721C228.8 89.2721 232.158 85.9142 232.158 81.7721H217.158ZM232.158 81.7721C232.158 76.5991 232.189 71.5815 231.423 67.5245C230.563 62.9751 228.527 58.6022 223.839 55.6228C219.791 53.0499 214.588 52.1021 208.963 51.6161C203.141 51.113 195.555 51.0316 185.924 51.0316V66.0316C195.66 66.0316 202.6 66.1222 207.672 66.5604C212.941 67.0157 215 67.7784 215.794 68.2825C215.947 68.3802 216.332 68.451 216.683 70.3089C217.127 72.6593 217.158 76.0129 217.158 81.7721H232.158Z",
    fill: "#5B5B5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M157.425 57.5053L192.071 29.792L192.377 84.8102L157.425 57.5053Z",
    fill: "#5B5B5B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 19.9937,
    y1: 38.9304,
    x2: 19.9937,
    y2: 77.2722,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 45.8164,
    x2: 4.5,
    y2: 71.2468,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 32.9051,
    y1: 26.019,
    x2: 32.9051,
    y2: 88.4621,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 47.538,
    y1: 4.5,
    x2: 47.538,
    y2: 112.563,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 60.4494,
    y1: 17.4114,
    x2: 60.4494,
    y2: 94.4873,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 75.9431,
    y1: 34.6266,
    x2: 75.9431,
    y2: 81.576,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 90.576,
    y1: 41.5127,
    x2: 90.576,
    y2: 71.2469,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 103.487,
    y1: 34.6266,
    x2: 103.487,
    y2: 77.2722,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 118.981,
    y1: 21.7152,
    x2: 118.981,
    y2: 90.1836,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 134.475,
    y1: 38.9304,
    x2: 134.475,
    y2: 77.2722,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 147.386,
    y1: 45.8164,
    x2: 147.386,
    y2: 71.2468,
    stroke: "#D86641",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 45.424,
    y2: -4.5,
    transform: "matrix(0 1 1 0 259.089 136)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 31.6519,
    y2: -4.5,
    transform: "matrix(0 1 1 0 272 142.886)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 68.6646,
    y2: -4.5,
    transform: "matrix(0 1 1 0 244.456 123.089)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 114.285,
    y2: -4.5,
    transform: "matrix(0 1 1 0 228.962 101.57)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 84.1582,
    y2: -4.5,
    transform: "matrix(0 1 1 0 216.051 114.481)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 48.8671,
    y2: -4.5,
    transform: "matrix(0 1 1 0 200.557 134.278)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 34.2342,
    y2: -4.5,
    transform: "matrix(0 1 1 0 185.924 140.304)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 47.1456,
    y2: -4.5,
    transform: "matrix(0 1 1 0 173.013 134.278)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 75.5506,
    y2: -4.5,
    transform: "matrix(0 1 1 0 157.519 118.785)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 45.424,
    y2: -4.5,
    transform: "matrix(0 1 1 0 144.608 136)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: -4.5,
    x2: 31.6519,
    y2: -4.5,
    transform: "matrix(0 1 1 0 129.975 142.886)",
    stroke: "#EEBBAA",
    strokeWidth: 9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay);
export default __webpack_public_path__ + "static/media/replay.84c126ac.svg";
export { ForwardRef as ReactComponent };